// extracted by mini-css-extract-plugin
module.exports = {"preTitle":"e_rg","content":"e_sg"};